import React, { Fragment } from 'react';
import classnames from 'classnames';

import Header from 'components/organisms/Header';
import Footer from 'components/organisms/Footer';
import ErrorBoundary from 'components/organisms/ErrorBoundary';
import Alert from 'components/atoms/Alert';
import Cookie from 'components/organisms/Cookie';

import styles from './index.css';

const App = ({
	children,
	loading = true,
	hideHeaderFooter,
	displayCookie,
	onAgreeCookie,
	routeName,
}) => (
	<Fragment>
		{!hideHeaderFooter && <Header />}
		<div
			className={classnames(styles.content, {
				[styles.show]: !loading,
				[styles.hideHeaderFooter]: hideHeaderFooter,
			})}
		>
			<ErrorBoundary>{children}</ErrorBoundary>
			{!hideHeaderFooter && <Footer />}
			{displayCookie && (
				<Cookie className={styles.cookie} onAgreeCookie={onAgreeCookie} routeName={routeName} />
			)}
		</div>
		<Alert className={styles.alert} namespace="generic">
			<br />Should not be display alert. Just for debug. It should be an API error
		</Alert>
	</Fragment>
);

export default App;



// WEBPACK FOOTER //
// ./src/layouts/App/component.js